import React, { useState, useEffect, useRef } from "react"
import { Button, DialogTitle, DialogContent, TextField, DialogActions, Grid, FormControl, FormLabel, FormControlLabel, Radio, Dialog, Checkbox, Table, TableContainer, TableHead, TableRow, Tooltip, TableCell, TableBody, IconButton } from "@material-ui/core"
import RadioGroup from "@material-ui/core/RadioGroup"
import CloseIcon from "@material-ui/icons/Close"
import InfoIcon from '@material-ui/icons/Info'
import GetAppIcon from '@material-ui/icons/GetApp'
import AttachmentIcon from '@material-ui/icons/Attachment'
import LinkIcon from '@material-ui/icons/Link'
import { fieldValidation } from "../../../../utils/formValidation"
import { formValues, taskErrorCode } from "../containers/ShopvisitTaskFormData"
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import moment from "moment"
import axios from 'axios'
import { validationMess } from "../../../../utils"
import MomentUtils from "@date-io/moment"
import { backendDateFormat, dayMonthDateFormat } from "../../../../constants"
import { addSvFormApi, deleteAdAttachment, resetTslsv_CslsvApi } from "../apiServices"
import { regexConstants } from "../../../../constants/regEx"
import { checkApiStatus, format_Commas } from "../../../../utils"
import { globalPutService, globalGetService } from "../../../../utils/globalApiServices"
import LinkFiles from "../../../../shared_elements/components/LinkFiles"
import UploadFile from "../../../../shared_elements/components/UploadFile"
import { assetType, imgStoragePath, specificKey } from "../../../../constants"
import config from "../../../../config"
import Switch from '@material-ui/core/Switch'
import { trackActivity } from "../../../../utils/mixpanel"
import { smbcInstance } from "../../../../shared_elements/components"
import { PageLoader } from "../../../../shared_elements"
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
const SvTaskForm = ({
    formTitle, closeAddForm, addForm, props, actionType,
    editFormId, editFormData, attachments: propAttachments,
    updateFormData, fileUploadData, uuid,
    last_used_folder_uuid, last_used_folder_uuid_link_document,
    checkbox_last_used_folder_uuid, checkbox_last_used_folder_name,
    getResponseBack: parentGetResponseBack,
}) => {
    const [error, setError] = useState({})
    const [opHistoryData, setOpHistoryData] = useState({})
    const [data, setData] = useState({ ...formValues })
    const [attachments, setAttachments] = useState([])
    const [newUploadedAttachments, setNewUploadedAttachments] = useState([])
    const [open, setOpen] = useState(false)
    const [showSuccessUpload, setShowSuccessUpload] = useState(false)
    const [linkFile, setLinkFile] = useState(false)
    const [uploadFile, setUploadFile] = useState(false)
    const [pagLoader, setPagLoader] = useState(false)
    const [engineModuleDropdown, setEngineModuleDropdown] = useState([])
    const [selectedModules, setSelectedModules] = useState({})
    const [engineModuleTableData, setEngineModuleTableData] = useState([])
    const [engineModuleErrors, setEngineModuleErrors] = useState([])
   
    const btnStatusRef = useRef("")
    const isEditInitRef = useRef(false)

    // Fields stay read-only while the removal-date API supplies their values; otherwise the user fills them in
    const hasApiTsnAtRemoval = !!opHistoryData?.tsn_at_removal_op_history?.toString()
    const hasApiCsnAtRemoval = !!opHistoryData?.csn_at_removal_op_history?.toString()
  
    useEffect(() => {
        if (editFormId) {
            setAttachments(propAttachments || [])
            setData(editFormData || {})
            offWingRemovalDetail(editFormData?.removal_date, true)
        }
        trackActivity('Shop Vists ADD Modal Opened - CAMO', {
            event_type: 'Modal Opened',
            page_title: 'Shop Vists Add Task Form',
        })
        getEngineModuleData()
    }, [])

    // When dropdown loads, initialize edit data (run once on dropdown load)
    useEffect(() => {
        if (engineModuleDropdown.length > 0) {
            if (!editFormData?.engine_module_data?.length) return
            const selectedMods = {}
            editFormData?.engine_module_data?.forEach(mod => {
                if (mod.module_name) selectedMods[mod.module_name] = true
            })
            isEditInitRef.current = true
            setSelectedModules(selectedMods)
        }
    }, [engineModuleDropdown])

    // Fetch module table data whenever selected modules change
    useEffect(() => {
        const selectedModuleNames = Object.keys(selectedModules).filter(k => selectedModules[k])
        if (selectedModuleNames?.length === 0) {
            setEngineModuleTableData([])
            setEngineModuleErrors([])
            setData(prev => ({ ...prev, engine_module_data: [] }))
            return
        }
        const isEdit = isEditInitRef.current
        isEditInitRef.current = false
        setPagLoader(true)
        const encodedModules = selectedModuleNames?.map(name => encodeURIComponent(name))?.join(",")
        globalGetService(`camo/engine_module_data/?modules=${encodedModules}&asset_id=${props?.match.params?.asset}`).then(res => {
            if (checkApiStatus(res)) {
                let apiData = res?.data?.engine_module_data || []
                if (data?.id && editFormData?.engine_module_data?.length) {
                    // Match by module_name (id may differ between saved and API data)
                    apiData = apiData?.map(row => {
                        const old = editFormData?.engine_module_data.find(d => d.module_name === row.module_name && d?.engine_id === row.id)
                        if (old) {
                            return { ...row, tsn: old.tsn || null, csn: old.csn || null, checked: true,svLinkedId:old?.id }
                        }
                       return row
                    })
                } else if (!isEdit) {
                    // Preserve rows already in the table so user edits are not lost
                    apiData = apiData.map(row => {
                        const existing = engineModuleTableData.find(d => d.id === row.id)
                        return existing || row
                    })
                }
                setEngineModuleTableData(apiData)
                setEngineModuleErrors([])
                setData(prev => ({
                    ...prev,
                    engine_module_data: apiData?.map(row => ({
                        id: row.id, module_name: row?.module_name || null, tsn: row?.tsn || null, csn: row?.csn || null, checked: row.checked || false,
                    }))
                }))
                setPagLoader(false)
            } else {
                setPagLoader(false)
            }
        })
    }, [selectedModules])
   

    const getEngineModuleData = () => {
        globalGetService(`camo/engine_module_dropdown/?asset_id=${props?.match.params?.asset}`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setEngineModuleDropdown(response?.data?.data || [])
                }
            })
    }
  
    const offWingRemovalDetail = (removalDate, isInitial = false) => {
        if (!removalDate || !moment(removalDate).isValid()) {
            setOpHistoryData({})
            if (!isInitial) {
                setData(prev => ({ ...prev, tsn_at_removal: null, csn_at_removal: null,removal_reason:null }))
            }
            return
        }
        globalGetService(`camo/get_removal_date_data/?asset_id=${props?.match.params?.asset}&asset_type_id=${props?.match.params?.assetType}&date_of_removal=${removalDate}`)
            .then(response => {
                const opHistory = checkApiStatus(response) ? response?.data?.data : null
                setOpHistoryData(opHistory || {})
                const isSameRemovalDate =
                    moment(removalDate).format(backendDateFormat) === moment(editFormData?.removal_date).format(backendDateFormat)
                setData(prev => ({
                    ...prev,
                    tsn_at_removal: opHistory?.tsn_at_removal_op_history?.toString() || (isInitial ? prev?.tsn_at_removal : null) || null,
                    csn_at_removal: opHistory?.csn_at_removal_op_history?.toString() || (isInitial ? prev?.csn_at_removal : null) || null,
                    removal_reason: isSameRemovalDate
                        ? (editFormData?.removal_reason ? editFormData?.removal_reason : (opHistory?.reason_for_removal || null))
                        : (opHistory?.reason_for_removal || null),
                }))
            })
    }
    console.log("data?.removal_reason ",data?.removal_reason )

    const onFieldChange = (keyParam, value, item) => {
        const newValue = keyParam === "sv_reset_tslsv_cslsv" ? !value : value
        setData(prev => ({ ...prev, [keyParam]: newValue }))
        if (keyParam === "sv_reset_tslsv_cslsv" && actionType !== "add") {
            resetTslsv_CslsvApi(props, item)
        }
        if (keyParam === "removal_date") {
            offWingRemovalDetail(value,false,)
        }
    }

    const onRestErrorKey = (keyParam) => {
        setError(prev => ({ ...prev, [keyParam]: "" }))
    }
    const handleModuleChange = (module) => {
        setSelectedModules(prev => ({ ...prev, [module?.module_name]: !prev[module?.module_name] }))
        // let engine_module_data = data?.engine_module_data.filter(item => item?.module_name !== module?.module_name)
        // setData(prev => ({ ...prev, engine_module_data }))
    }

    const updateEngineModuleField = (field, value, index) => {
        const updated = [...engineModuleTableData]
        updated[index] = { ...updated[index], [field]: value }
        const engine_module_data = updated?.map(row => ({
            id: row.id, module_name: row?.module_name, tsn: row.tsn || null, csn: row.csn || null, checked: row.checked || false,
        }))
        setEngineModuleTableData(updated)
        setData(prev => ({ ...prev, engine_module_data }))
    }

    const setRowError = (index, field, msg) => {
        setEngineModuleErrors(prev => {
            const updated = [...prev]
            updated[index] = { ...(updated[index] || {}), [field]: msg }
            return updated
        })
    }

    const handleInputChange = (field, value, index) => {
        if (field === "tsn") {
            const formatted = format_Commas(value).replace(/[^0-9.]/g, '')
            const numericValue = value.replace(/[^\d.]/g, '')
            const dotCount = (numericValue.match(/\./g) || []).length
            const isValid = dotCount
                ? numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)
                : formatted.length <= 5 && regexConstants.numberWithDot.test(numericValue)

            if (regexConstants.alphanumespcespclchar.test(value)) {
                const errMsg = value ? (!specificKey.includes(value.toUpperCase()) && validationMess("TSN", true)) : ''
                setRowError(index, "tsn", errMsg || '')
                updateEngineModuleField(field, value, index)
            } else if (isValid || value === "") {
                setRowError(index, "tsn", '')
                updateEngineModuleField(field, numericValue, index)
            }
        } else if (field === "csn") {
            if (regexConstants.alphanumespcespclchar.test(value)) {
                const errMsg = value ? (!specificKey.includes(value.toUpperCase()) && validationMess("CSN", false)) : ''
                setRowError(index, "csn", errMsg || '')
                updateEngineModuleField(field, value, index)
            } else {
                const numericValue = value.replace(/[^0-9]/g, '')
                if (numericValue.length <= 5 || value === "") {
                    setRowError(index, "csn", '')
                    updateEngineModuleField(field, numericValue, index)
                }
            }
        } else {
            updateEngineModuleField(field, value, index)
        }
    }

    const buildValidation = (formData) => ({
        removal_date: taskErrorCode["removal_date"][fieldValidation({ ...taskErrorCode["removal_date_obj"], fieldval: formData.removal_date })],
        removal_reason: taskErrorCode["removal_reason"][fieldValidation({ ...taskErrorCode["removal_reason_obj"], fieldval: formData.removal_reason })],
        // tsn_at_removal: taskErrorCode["tsn_at_removal"][fieldValidation({ ...taskErrorCode["tsn_at_removal_obj"], fieldval: formData.tsn_at_removal })],
        // csn_at_removal: taskErrorCode["csn_at_removal"][fieldValidation({ ...taskErrorCode["csn_at_removal_obj"], fieldval: formData.csn_at_removal })],
        sv_completion_date: taskErrorCode["sv_completion_date"][fieldValidation({ ...taskErrorCode["sv_completion_date_obj"], fieldval: formData.sv_completion_date })],
        sv_type: taskErrorCode["sv_type"][fieldValidation({ ...taskErrorCode["sv_type_obj"], fieldval: formData.sv_type })],
    })

    const buildPayload = (formData) => ({
        ...formData,
        engine_module_data: (formData?.engine_module_data || [])?.filter(row => row?.checked),
        asset_id: props.match.params.asset,
        asset_type_id: props.match.params.assetType,
        sv_type: formData.sv_type || null,
        tsn_at_removal: formData.tsn_at_removal || null,
        csn_at_removal: formData.csn_at_removal || null,
        min_build_standard: formData.min_build_standard || null,
        target_on_wing_hours: formData.target_on_wing_hours || null,
        target_on_wing_cycle: formData.target_on_wing_cycle || null,
        induction_date: formData.induction_date || null,
        expected_date: formData.expected_date || null,
    })

    const onSubmitFileLink = (id) => {
        if (data?.checklist?.length > 0 && data.checklist.map(i => i.id).filter(i => i)) {
            let payload = {}
            const hasFolder = data.checklist.some(i => i.type === 'folder')
            const hasFile = data.checklist.some(i => i.type === 'file')
            if (hasFolder) payload.folder_ids = data.checklist.filter(i => i.type === 'folder').map(f => f.id).join(',')
            if (hasFile) payload.file_ids = data.checklist.filter(i => i.type === 'file').map(f => f.id).join(',')
            globalPutService(`camo/shop/${id}/document-checklists/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        parentGetResponseBack()
                    } else {
                        props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                })
        }
        if (data?.folder_uuid?.length > 0) {
            const formData = new FormData()
            formData.append('folder_uuid', data.folder_uuid)
            const fileChecklist = data.checklist.filter(i => i instanceof File)
            for (let i = 0; i < fileChecklist.length; i++) {
                formData.append('files[]', fileChecklist[i])
            }
            globalPutService(`camo/shop/${id}/document-checklists/`, formData)
                .then(response => {
                    if (checkApiStatus(response)) {
                        parentGetResponseBack()
                    } else {
                        props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                })
        }
    }

    const resetBothAttachmentArray = () => {
        setData(formValues)
        setAttachments([])
        setNewUploadedAttachments([])
        setEngineModuleTableData([])
        setSelectedModules({})
        setOpen(false)
        document.getElementById("asset-form").reset()
    }

    const uploadFileTest = async (uploadId, isUpdate) => {
        if (newUploadedAttachments.length > 0) {
            const formdata = new FormData()
            const module_type_id = 9
            Object.keys(newUploadedAttachments).forEach((key) => {
                formdata.append(`[${key}]file`, newUploadedAttachments[key])
                formdata.append(`[${key}]file_type`, newUploadedAttachments[key].type)
                formdata.append(`[${key}]file_name`, newUploadedAttachments[key].name)
                formdata.append(`[${key}]module_id`, uploadId)
                formdata.append(`[${key}]module_type_id`, module_type_id)
                formdata.append(`[${key}]asset_id`, props.match.params.asset)
                formdata.append(`[${key}]asset_type_id`, props.match.params.assetType)
            })
            fileUploadData(uploadId, formdata, props, true)
            if (btnStatusRef.current === "addAnother") {
                resetBothAttachmentArray()
            }
            if (!isUpdate) {
                onSubmitFileLink(uploadId)
                fileUploadData(uploadId, null, props, false)
            }
        } else {
            if (btnStatusRef.current === "addAnother") {
                setData(formValues)
                setEngineModuleTableData([])
                setSelectedModules({})
                setAttachments([])
                document.getElementById("asset-form").reset()
                fileUploadData(uploadId, null, props, false)
            } else if (!isUpdate) {
                onSubmitFileLink(uploadId)
                fileUploadData(uploadId, null, props, false)
            }
        }
    }

    const hasEngineModuleErrors = () =>
        engineModuleErrors.some(row => row?.tsn || row?.csn)

    const handleSubmit = (e) => {
        e.preventDefault()
        const validationInputs = buildValidation(data)
        if (Object.keys(validationInputs).every(k => validationInputs[k] === "") && !hasEngineModuleErrors()) {
            const payload = buildPayload(data)
            setPagLoader(true)
            addSvFormApi(payload, props, addForm).then(async (response) => {
                const uploadId = response.data?.data?.id
                if (uploadId) {
                    trackActivity('Shop Vists Data Added Successfully - CAMO', {
                        event_type: 'Task Added Successfully',
                        page_title: 'Shop Vists',
                        item_id: uploadId,
                        request_body: payload,
                        response_msg: response?.data?.message || '',
                    })
                    await uploadFileTest(uploadId, false)
                }
                if (uploadId && btnStatusRef.current !== "addAnother") {
                    closeAddForm()
                } else {
                    setPagLoader(false)
                    return false
                }
                setPagLoader(false)
            })
        } else {
            setError(validationInputs)
            trackActivity('Shop Vist Data Added Failed - CAMO', {
                event_type: 'Add TASK Failed',
                page_title: 'Shop Vist',
                error_source: 'Frontend',
                error_type: validationInputs,
            })
        }
    }

    const updateData = async (e) => {
        e.preventDefault()
        const validationInputs = buildValidation(data)
        if (Object.keys(validationInputs).every(k => validationInputs[k] === "") && !hasEngineModuleErrors()) {
            const payload = buildPayload(data)
            if (editFormId) {
                await uploadFileTest(editFormId, true)
                trackActivity('Shop Vists Data Updated Successfully - CAMO', {
                    event_type: 'Task Updated Successfully',
                    page_title: 'Shop Vists',
                    item_id: editFormId,
                    request_body: payload,
                })
            }
            await updateFormData(editFormId, payload, props, addForm, closeAddForm)
        } else {
            setError(validationInputs)
            trackActivity('Shop Vists Data Updated Failed - CAMO', {
                event_type: 'Update TASK Failed',
                page_title: 'Shop Vists',
                error_source: 'Frontend',
                error_type: validationInputs,
            })
        }
    }

    const handleUploadFiles = (files) => {
        const uploaded = [...newUploadedAttachments]
        const existingAttachments = [...attachments]
        files.forEach(file => {
            uploaded.push(file)
            existingAttachments.push({
                id: 0, module_id: 0, module_type_id: 9,
                file_name: file.name, file_type: file.type, file: "", name: file.name,
                asset_id: props.match.params.asset,
                asset_type_id: props.match.params.assetType,
            })
        })
        setNewUploadedAttachments(uploaded)
        setAttachments(existingAttachments)
    }

    const onUpload = (files) => {
        const chosenFiles = Array.prototype.slice.call(files)
        for (let i = 0; i < chosenFiles.length; i++) {
            if (chosenFiles[i].size > 52428800) {
                props.enqueueSnackbar(`${chosenFiles[i].name} Maximum file size should be 50MB.`, {
                    variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" },
                })
                delete chosenFiles[i]
            } else {
                handleUploadFiles(chosenFiles)
                setShowSuccessUpload(true)
                setTimeout(() => setShowSuccessUpload(false), 2500)
            }
        }
    }

    const deleteAttachmentFile = async (id, file) => {
        if (id !== undefined && id !== 0) {
            deleteAdAttachment(id, props)
            setAttachments(prev => prev.filter(a => a.id !== id))
            setOpen(false)
        } else {
            onRemoveCamoFile(file)
        }
    }

    const removeAttachment = (e, obj) => {
        setNewUploadedAttachments(prev => prev.filter(f => !(f.name === obj.file_name && f.type === obj.file_type)))
        setAttachments(prev => prev.filter(a => a !== obj))
    }

    const saveAndAddAnother = async (e) => {
        btnStatusRef.current = "addAnother"
        await handleSubmit(e)
    }

    const addFormData = async (e) => {
        btnStatusRef.current = "add"
        handleSubmit(e)
    }

    const getResponseBack = (file) => {
        setData(prev => ({ ...prev, checklist: file }))
    }

    const listResponseBack = () => null

    const downloadFile = (file) => {
        axios.get(decodeURIComponent(file.path), { timeout: 600000, responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', file.name)
                document.body.appendChild(link)
                link.click()
            })
    }

    const onUnlinkCheckListFile = (checklist, fileId) => {
        const payload = {
            delete: true,
            folder_ids: checklist?.folders?.filter(i => i.type === 'folder').map(f => f.id).filter(id => id !== fileId).join(','),
            file_ids: checklist?.files?.filter(i => i.type === 'file').map(f => f.id).filter(id => id !== fileId).join(','),
        }
        globalPutService(`camo/shop/${editFormId}/document-checklists/`, payload)
            .then(response => {
                if (checkApiStatus(response)) {
                    setData(prev => ({
                        ...prev,
                        checklist: {
                            ...prev.checklist,
                            files: prev.checklist.files?.filter(f => f.id !== fileId) || [],
                            folders: prev.checklist.folders?.filter(f => f.id !== fileId) || [],
                        },
                    }))
                }
                trackActivity('Shop Visits Status - CAMO', {
                    event_type: 'Checklist File Unlinked',
                    page_title: 'Shop Visits',
                    file_id: fileId || '',
                    edited_form_id: editFormId || '',
                    request_body: payload,
                })
            })
    }

    const onRemoveFile = (file) => {
        setData(prev => ({ ...prev, checklist: prev.checklist.filter(i => i.name !== file.name) }))
    }

    const onRemoveCamoFile = (file) => {
        setAttachments(prev => prev.filter(a => a.file_name !== file.file_name))
    }

    const onLinkFile = (file, uuid, type) => {
        if (type === "link" || uuid) {
            setData(prev => {
                const rawFolderUUID = [...(Array.isArray(prev.folder_uuid) ? prev.folder_uuid : []), uuid]
                const rawChecklist = [...(Array.isArray(prev.checklist) ? prev.checklist : []), file]
                return { ...prev, checklist: rawChecklist.flat(), folder_uuid: rawFolderUUID.flat() }
            })
        } else {
            onUpload(file)
        }
    }

    let timezone = moment().format()
    const timestamp = Math.floor(Date.now() / 1000);
   
    return (
        <div id="AmpTaskForm">
            {pagLoader ? <PageLoader /> : null}
            <div id="HtTaskForm">
                <DialogTitle>
                    {formTitle}
                    <CloseIcon onClick={() => { closeAddForm(); listResponseBack() }} className="close-icon" />
                </DialogTitle>
                <form
                    id="asset-form"
                    onSubmit={actionType === "add" ? handleSubmit : updateData}
                >
                    <DialogContent>
                        <Grid spacing={1} container>
                            <Grid item md={3} sm={6} xs={12}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        required
                                        id="removal_date"
                                        label="Removal Date"
                                        format={dayMonthDateFormat}
                                        inputVariant="outlined"
                                        fullWidth
                                        disableFuture
                                        onPaste={(event) => event.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        minDate={moment().subtract(25, "years")}
                                        value={data.removal_date}
                                        error={!!error.removal_date}
                                        helperText={error.removal_date || ""}
                                        onFocus={() => onRestErrorKey("removal_date")}
                                        onChange={(val) => {
                                            onFieldChange("removal_date", moment(val).format(backendDateFormat))
                                            onRestErrorKey("removal_date")
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    required
                                    variant="outlined"
                                    label="Removal Reason"
                                    name="removal_reason"
                                    id="removal_reason"
                                    inputProps={{ maxLength: 100 }}
                                    value={data?.removal_reason ? data?.removal_reason : ''}
                                    InputLabelProps={{ shrink: true }}
                                    error={!!error.removal_reason}
                                    helperText={error.removal_reason || ""}
                                    onChange={(e) => { onFieldChange("removal_reason", e.target.value); onRestErrorKey("removal_reason") }}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    // required
                                    variant="outlined"
                                    label={
                                        <span style={{ verticalAlign: 'super' }}>
                                            TSN at Removal
                                            <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
                                                <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                            </Tooltip>
                                        </span>
                                    }
                                    id="tsn_at_removal"
                                    disabled={hasApiTsnAtRemoval}
                                    inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.tsn_at_removal) && 10 }}
                                    InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                    value={format_Commas(data?.tsn_at_removal) || ''}
                                    error={!!error.tsn_at_removal}
                                    helperText={error.tsn_at_removal || ""}
                                    onChange={(e) => {
                                        const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '')
                                        const numericValue = value.replace(/[^\d.]/g, '')
                                        const dotCount = (numericValue.match(/\./g) || []).length
                                        const isValid = dotCount
                                            ? (numericValue.replace(".", "").length - dotCount <= 6 && regexConstants.numberWithDot.test(numericValue))
                                            : value.length <= 5 && regexConstants.numberWithDot.test(numericValue)
                                        if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                            onFieldChange("tsn_at_removal", e.target.value)
                                            setError(prev => ({ ...prev, tsn_at_removal: e.target.value === (null || undefined || "") ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('TSN at Removal', true) }))
                                        } else if (isValid || value === "") {
                                            onFieldChange("tsn_at_removal", numericValue)
                                            setError(prev => ({ ...prev, tsn_at_removal: "" }))
                                            setTimeout(() => onRestErrorKey("tsn_at_removal"), 9000)
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    // required
                                    variant="outlined"
                                    label={
                                        <span style={{ verticalAlign: 'super' }}>
                                            CSN at Removal
                                            <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99,999</span>} arrow>
                                                <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                            </Tooltip>
                                        </span>
                                    }
                                    id="csn_at_removal"
                                    disabled={hasApiCsnAtRemoval}
                                    InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                    inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.csn_at_removal) && 9 }}
                                    error={!!error.csn_at_removal}
                                    helperText={error.csn_at_removal || ""}
                                    // value={regexConstants.alphanumespcespclchar.test(data.csn_at_removal) ? data.csn_at_removal : format_Commas(data?.csn_at_removal.toString().replace(/[^0-9.]/g, ''))}
                                    value={format_Commas(data?.csn_at_removal) || ''}
                                    onChange={(e) => {
                                        if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                            onFieldChange("csn_at_removal", e.target.value)
                                            setError(prev => ({ ...prev, csn_at_removal: e.target.value === (null || undefined || "") ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('CSN at Removal', false) }))
                                        } else {
                                            setError(prev => ({ ...prev, csn_at_removal: "" }))
                                            const numericValue = e.target.value.replace(/,/g, '')
                                            numericValue.length <= 5 && (regexConstants.onlyNumeric.test(numericValue) || numericValue === "") && onFieldChange('csn_at_removal', numericValue)
                                            onRestErrorKey("csn_at_removal")
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={1} container>
                            <Grid item md={3} sm={6} xs={12}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        required
                                        id="sv_completion_date"
                                        label="Shop Visit Completion Date"
                                        format={dayMonthDateFormat}
                                        inputVariant="outlined"
                                        fullWidth
                                        disableFuture
                                        onPaste={(event) => event.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        minDate={moment().subtract(25, "years")}
                                        value={data.sv_completion_date}
                                        error={!!error.sv_completion_date}
                                        helperText={error.sv_completion_date || ""}
                                        onFocus={() => onRestErrorKey("sv_completion_date")}
                                        onChange={(val) => {
                                            onFieldChange("sv_completion_date", moment(val).format(backendDateFormat))
                                            onRestErrorKey("sv_completion_date")
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    variant="outlined"
                                    label="Shop Visit Location /MRO"
                                    name="sv_location_mro"
                                    id="sv_location_mro"
                                    value={data.sv_location_mro}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 50 }}
                                    onChange={(e) => onFieldChange("sv_location_mro", e.target.value)}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    variant="outlined"
                                    label="Shop Visit Workscope"
                                    name="sv_workscope"
                                    id="sv_workscope"
                                    InputLabelProps={{ shrink: true }}
                                    value={data.sv_workscope}
                                    inputProps={{ maxLength: 100 }}
                                    onChange={(e) => onFieldChange("sv_workscope", e.target.value)}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    label="Min Build Standard"
                                    margin='normal'
                                    variant='outlined'
                                    fullWidth
                                    value={data.min_build_standard}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => onFieldChange("min_build_standard", e.target.value)}
                                    inputProps={{ maxLength: 50 }}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={1} container>
                            <Grid item md={3} sm={6} xs={12}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        id="induction_date"
                                        label="Induction Date"
                                        format={dayMonthDateFormat}
                                        inputVariant="outlined"
                                        fullWidth
                                        disabled={!data.removal_date}
                                        onPaste={(event) => event.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        minDate={moment(data.removal_date)}
                                        value={data.induction_date}
                                        error={!!error.induction_date}
                                        helperText={error.induction_date || ""}
                                        onFocus={() => onRestErrorKey("induction_date")}
                                        onChange={(val) => {
                                            onFieldChange("induction_date", moment(val).format(backendDateFormat))
                                            onRestErrorKey("induction_date")
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        id="expected_date"
                                        label="Expected Date"
                                        format={dayMonthDateFormat}
                                        inputVariant="outlined"
                                        fullWidth
                                        disablePast
                                        onPaste={(event) => event.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        minDate={moment(new Date())}
                                        value={data.expected_date}
                                        error={!!error.expected_date}
                                        helperText={error.expected_date ? error.induction_date : ""}
                                        onFocus={() => onRestErrorKey("expected_date")}
                                        onChange={(val) => {
                                            onFieldChange("expected_date", moment(val).format(backendDateFormat))
                                            onRestErrorKey("expected_date")
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    variant="outlined"
                                    name="target_on_wing_hours"
                                    id="target_on_wing_hours"
                                    label="Target On Wing Hours"
                                    InputLabelProps={{ shrink: true }}
                                    value={data.target_on_wing_hours || ''}
                                    onChange={(e) => {
                                        const value = e.target.value
                                        const numericValue = value.replace(/[^\d.]/g, '')
                                        const dotCount = (numericValue.match(/\./g) || []).length
                                        const isValid = dotCount
                                            ? (numericValue.replace(".", "").length - dotCount <= 6 && regexConstants.numberWithDot.test(numericValue))
                                            : value.length <= 5 && regexConstants.numberWithDot.test(numericValue)
                                        if (isValid || value === "") onFieldChange("target_on_wing_hours", numericValue)
                                    }}
                                    onPaste={(e) => e.preventDefault()}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    variant="outlined"
                                    name="target_on_wing_cycle"
                                    label="Target On Wing Cycle"
                                    id="target_on_wing_cycle"
                                    inputProps={{ maxLength: 5 }}
                                    InputLabelProps={{ shrink: true }}
                                    value={data.target_on_wing_cycle || ''}
                                    onChange={(e) => (e.target.value || e.target.value === '') && (regexConstants.onlyNumeric.test(e.target.value) || e.target.value === "") && onFieldChange('target_on_wing_cycle', e.target.value)}
                                    onPaste={(e) => e.preventDefault()}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={1} container>
                            <Grid item md={3} sm={6} xs={12}>
                                <h5 style={{ color: '#0000008a' }}>Click Toggle to Reset {smbcInstance ? "TSPR and CSPR" : "TSLSV and CSLSV"}</h5>
                                <Switch
                                    checked={data?.sv_reset_tslsv_cslsv}
                                    onChange={() => onFieldChange("sv_reset_tslsv_cslsv", data?.sv_reset_tslsv_cslsv, data?.id)}
                                    color="primary"
                                    id="sv_reset_tslsv_cslsv"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <label>Shop Visit Type <span style={{ color: "red" }}> *</span></label>
                                <FormControl id="d-block" style={{ width: 'max-content' }}>
                                    <FormLabel component="legend" error={!!error.sv_type}></FormLabel>
                                    <RadioGroup
                                        row
                                        aria-label="sv_type"
                                        name="sv_type"
                                        defaultValue="top"
                                        value={data.sv_type}
                                        onChange={(e) => { onFieldChange("sv_type", e.target.value); setError(prev => ({ ...prev, sv_type: '' })) }}
                                    >
                                        <FormControlLabel value="PRSV" control={<Radio size="small" color="primary" />} label="PRSV" />
                                        <FormControlLabel value="Repair" control={<Radio size="small" color="primary" />} label="Repair" />
                                        <FormControlLabel value="Overhaul" control={<Radio size="small" color="primary" />} label="Overhaul" />
                                    </RadioGroup>
                                    {error.sv_type && (
                                        <FormLabel component="faa_easa"><span style={{ color: "red" }}>{error.sv_type}</span></FormLabel>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item md={12} sm={12} xs={12}>
                                <label style={{ fontWeight: 600, marginRight: '10px' }}>Engine Modules</label>
                                {engineModuleDropdown?.map(module => (
                                    <FormControlLabel
                                        key={module.id}
                                        control={
                                            <Checkbox
                                                checked={selectedModules[module?.module_name] || false}
                                                onChange={() => handleModuleChange(module)}
                                                color="primary"
                                            />
                                        }
                                        label={module.module_name}
                                    />
                                ))}
                                {engineModuleTableData?.length > 0 && (
                                    <TableContainer style={{ maxHeight: '450px', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                                        <Table className='mui-table-format' stickyHeader={true} >
                                            <TableHead style={{ zIndex: 1, position: 'sticky' }} className="engine-module-table">
                                                <TableRow >
                                                    <TableCell style={{ fontWeight: 'bold' }}>Action(s)</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Sections</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>TSN</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>CSN</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {engineModuleTableData?.map((row, index) => (
                                                    <TableRow key={row?.section_id} className="engine-module-table">
                                                        <TableCell>
                                                            <Checkbox
                                                                checked={!!row?.checked}
                                                                onChange={() => updateEngineModuleField('checked', !row.checked, index)}
                                                                size="small"
                                                                color="primary"
                                                            />
                                                            <span>
                                                                <Tooltip placement='right' title={<span>only checked sections will be linked to this shop visit</span>} arrow>
                                                                   <IconButton style={{cursor:'auto'}}><InfoIcon color="primary" style={{fontSize: 'large' }} /></IconButton> 
                                                                </Tooltip>
                                                            </span>
                                                           {row?.svLinkedId ?<RevisionHistory  buttonType={true} url={`audit/camo/shopvisitenginemodule/?object_id=${row?.svLinkedId}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`} source={true}/> : null}
                                                        </TableCell>
                                                        <TableCell>{row?.section || '--'}</TableCell>
                                                        <TableCell>{row?.description || '--'}</TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                disabled={!row?.checked}
                                                                value={row?.tsn == null ? '' : regexConstants.alphanumespcespclchar.test(row.tsn) ? row.tsn : format_Commas(row.tsn.replace(/[^0-9.]/g, ''))}
                                                                onChange={e => handleInputChange("tsn", e.target.value, index)}
                                                                error={!!engineModuleErrors[index]?.tsn}
                                                                helperText={engineModuleErrors[index]?.tsn || ''}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                disabled={!row?.checked}
                                                                value={row?.csn == null ? '' : regexConstants.alphanumespcespclchar.test(row.csn) ? row.csn : format_Commas(row.csn.toString().replace(/[^0-9.]/g, ''))}
                                                                inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(row.csn) && 9 }}
                                                                onChange={e => handleInputChange("csn", e.target.value, index)}
                                                                error={!!engineModuleErrors[index]?.csn}
                                                                helperText={engineModuleErrors[index]?.csn || ''}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </Grid>
                        </Grid>
                        <div className="border-grey"></div>
                        <Grid spacing={1} container>
                            <Grid item md={6} sm={6} xs={12}>
                                <TextField
                                    label="Remarks"
                                    margin='normal'
                                    variant='outlined'
                                    fullWidth
                                    value={data.remarks}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => onFieldChange("remarks", e.target.value)}
                                    rows={3}
                                    multiline
                                    inputProps={{ maxLength: 250 }}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <div className="upload-amp-textbox" style={{ border: "1px solid gray", textAlign: 'center' }}>
                                    <ul className="list-inline spacing-list">
                                        <li className="list-inline-item" onClick={() => setUploadFile(true)}>
                                            <span className="flex-centered"><AttachmentIcon color='primary' fontSize='small' /> Upload File</span>
                                        </li>
                                        <li className="list-inline-item" onClick={() => setLinkFile(true)}>
                                            <span className="flex-centered"><LinkIcon color='primary' fontSize='small' />Link file from Records Module</span>
                                        </li>
                                    </ul>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid id="data-container" spacing={1} container>
                            <Grid spacing={1} container>
                                {actionType === 'add' ? (
                                    <div className='checklist-files'>
                                        <ul className='list-inline'>
                                            {data?.checklist?.map((file) => (
                                                <li className='list-inline-item' key={file.name}>
                                                    <span className='file-name'>{file.name}</span>
                                                    <span className='file-remove'>
                                                        <a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
                                                        <CloseIcon onClick={() => onRemoveFile(file)} color='secondary' fontSize='small' />
                                                    </span>
                                                </li>
                                            ))}
                                            {attachments?.map((att) => (
                                                <li className='list-inline-item' key={att.file_name}>
                                                    <span className='file-name'>{att.file_name}</span>
                                                    <span className='file-remove'>
                                                        <a href={decodeURIComponent(att.file)} download={att.file_name}><GetAppIcon color="primary" /></a>
                                                        <CloseIcon onClick={() => onRemoveCamoFile(att)} color='secondary' fontSize='small' />
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ) : (
                                    <div className='checklist-files'>
                                        <ul className='list-inline'>
                                            {data?.checklist?.files?.map((file) => (
                                                <li className='list-inline-item' key={file.id}>
                                                    <span className='file-name'>{file.name}</span>
                                                    <span className='file-remove'>
                                                        <a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
                                                        <CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
                                                    </span>
                                                </li>
                                            ))}
                                            {data.checklist?.folders?.length > 0 && data.checklist.folders.map((file) => (
                                                <li className='list-inline-item' key={file.id}>
                                                    <Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
                                                        <a href={`${config.domain.records}${assetType[props?.match.params.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new">
                                                            <img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Records Data Room" />
                                                        </a>
                                                    </Tooltip>
                                                    <span className='file-name'>{file.name}</span>
                                                    <span className='file-remove'>
                                                        <CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
                                                    </span>
                                                </li>
                                            ))}
                                            {attachments?.map((att) => (
                                                <li className='list-inline-item' key={att.file_name}>
                                                    <span className='file-name'>{att.file_name}</span>
                                                    <span className='file-remove'>
                                                        <a href={decodeURIComponent(att.file)} download={att.file_name}><GetAppIcon color="primary" /></a>
                                                        <CloseIcon onClick={() => deleteAttachmentFile(att.id, att)} color='secondary' fontSize='small' />
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className="actions-btn">
                        <Button
                            disabled={pagLoader}
                            type="button"
                            className="btn btn-primary"
                            onClick={actionType === "add" ? addFormData : updateData}
                        >
                            {actionType === "add" ? "Add" : "Update"}
                        </Button>
                        {actionType === "add" && (
                            <Button onClick={saveAndAddAnother} type="button" className="btn btn-primary">Save & Add Another</Button>
                        )}
                        <Button type="button" className="btn btn-primary" onClick={() => { closeAddForm(); listResponseBack() }}>Close</Button>
                    </DialogActions>
                    <Dialog open={linkFile} onClose={() => setLinkFile(false)} id="htDialog">
                        <LinkFiles
                            handleClose={() => setLinkFile(false)}
                            uuid={uuid?.uuid}
                            editFormId={editFormId}
                            getResponseBack={(file) => getResponseBack(file)}
                            listResponseBack={(file) => listResponseBack(file)}
                            actionType={actionType}
                            onLinkFile={(file, any, type) => onLinkFile(file, any, type)}
                            modType="shop"
                            last_used_folder_uuid={last_used_folder_uuid_link_document}
                            uploadFileInfo={data}
                            attachments={attachments}
                            type="link"
                        />
                    </Dialog>
                    <Dialog open={uploadFile} onClose={() => setUploadFile(false)} id="htDialog">
                        <UploadFile
                            handleClose={() => setUploadFile(false)}
                            uuid={uuid?.uuid}
                            editFormId={editFormId}
                            getResponseBack={(file) => getResponseBack(file)}
                            listResponseBack={(file) => listResponseBack(file)}
                            actionType={actionType}
                            onLinkFile={(file, uid) => onLinkFile(file, uid)}
                            modType="shop"
                            uploadFileInfo={data}
                            last_used_folder_uuid={last_used_folder_uuid}
                            onUpload={(file) => onUpload(file)}
                            type="upload"
                            checkbox_last_used_folder_uuid={checkbox_last_used_folder_uuid}
                            checkbox_last_used_folder_name={checkbox_last_used_folder_name}
                        />
                    </Dialog>
                </form>
            </div>
        </div>

    )
}

export default SvTaskForm
